export default "__VITE_ASSET__CSNQsnHJ__"